module.exports = {
  GOOGLE: 'google',
  SKOLETUBE: 'skoletube',
  MICROSOFT: 'microsoft',
}
